export default "__VITE_ASSET__b890b435__"